module.exports = __webpack_public_path__ + "img/171.food_variety.ee094014.svg";